(() => {
  angular
    .module('gm.common.filters')
    .filter('gmRecipientDescription', gmRecipientDescriptionFilter);

  function gmRecipientDescriptionFilter() {
    'ngInject';

    function getContactText(contact) {
      const address = (contact) ? (contact.email || contact.phone) : '';
      if (contact) {
        return (contact.name) ? `${contact.name} <${address}>` : address;
      }
      return '';
    }

    return (recipients) => {
      let description;

      if (angular.isArray(recipients)) {
        if (recipients.length > 1) {
          const descriptions = recipients.map(el => getContactText(el));

          description = descriptions.reduce((r1, r2) => `${r1}, ${r2}`);
        } else {
          description = getContactText(recipients[0]);
        }
      } else {
        description = getContactText(recipients);
      }

      return description;
    };
  }
})();
